import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';

import { SupportedPaymentMethod } from '@mews/enums';
import { PaymentCardImageTypes } from '@mews/framework/payments';

import { getSelectedEnterpriseSupportedPaymentCardImageTypes } from '../../../../modules/paymentConfigurations/selectors';
import { getSelectedEnterpriseSupportedPaymentMethods } from '../../../../selectors/views/selectedEnterprisePaymentConfiguration';
import { ApplicationState } from '../../../../types';

interface StateProps {
    cardTypes: Array<keyof PaymentCardImageTypes>;
    paymentMethods: Array<SupportedPaymentMethod>;
}

export const inject = connect<StateProps, {}, {}, ApplicationState>(
    createStructuredSelector<ApplicationState, {}, StateProps>({
        cardTypes: getSelectedEnterpriseSupportedPaymentCardImageTypes,
        paymentMethods: getSelectedEnterpriseSupportedPaymentMethods,
    })
);
